import React from 'react';
import Check from '@mui/icons-material/Check';
import { StepIconProps } from '@mui/material/StepIcon';
import { QontoStepIconRoot } from './components';

type QontoStepIconProps = StepIconProps & {
  variant?: 'horizontal' | 'vertical';
};

export default function QontoStepIcon(props: QontoStepIconProps) {
  const {
    active, completed, className, variant = 'horizontal',
  } = props;

  const renderIcon = () => {
    if (variant === 'horizontal') {
      if (completed) {
        return <Check className="QontoStepIcon-completedIcon" />;
      }
      return <div className="QontoStepIcon-circle" />;
    }

    if (active) {
      return <div className="QontoStepIcon-activeCircle" />;
    }
    return <div className="QontoStepIcon-borderCircle" />;
  };

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {renderIcon()}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.defaultProps = {
  variant: 'horizontal',
};
